// import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import Product from '@common/models/Product';
import { addProductToCart } from '@common/store/cart/slice';
import { subtractProductFromCart } from '@common/store/cart/slice';
import { addToast } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
// import StarRating from '@components/Rating/StarRating';
// import Share from '@components/Share';
// import Close from '@images/Close.svg';
// import Rupee from '@instamojo/rupee';
// import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';

interface EventProps {
  product: Product;
  addProductToCart: typeof addProductToCart;
  cartProductQuantity: number;
  addToast: typeof addToast;
  storeType: string;
  subtractProductFromCart: typeof subtractProductFromCart;
  quickView?: boolean;
  onClose?: () => void;
  review: number;
  scrollToReview?: () => void;
  wishListFeature: boolean;
  finalProduct: Product;
  hocArgs: unknown;
  productVideoFeature: boolean;
}

const Event: React.FC<EventProps> = ({
  product,
  addProductToCart,
  subtractProductFromCart,
  cartProductQuantity,
  addToast,
  storeType,
  review,
  // onClose,
  quickView,
  scrollToReview,
  wishListFeature,
  finalProduct,
  hocArgs,
  productVideoFeature,
}) => {
  // const StarRatingValue = finalProduct.averageRating;
  return (
    <div className="w-full">
      <div className={classnames(`bg-white rounded-md `)}>
        <div className="flex flex-wrap md:flex-no-wrap">
          <div className={classnames('w-full md:w-fit')}>
            <Gallery
              isZoomEnabled={false}
              images={finalProduct.images.length ? finalProduct.images : product.images}
              quickView={quickView}
              inStock={finalProduct.inStock}
              imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
              }`}
              productVideoUrl={finalProduct.productVideoUrl}
              productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
            />
          </div>
          <div className={`flex flex-col md:ml-20 xl:ml-30 mt-24 md:mt-0 w-full md:w-fit xl:w-470`}>
            <div className="">
              <div
                className={classnames(
                  'flex text-26 md:text-46 leading-31 md:leading-55 font-extrabold text-title content-start',
                )}
                font-customisation="section-heading"
                color-customisation="page-heading"
              >
                {finalProduct.title}
              </div>
              {/* <div className="flex items-center my-10">
                      {parseInt(StarRatingValue) > 0 ? (
                        <div className=" flex pr-4 ">
                          <StarRating
                            rating={parseInt(StarRatingValue) ? parseInt(StarRatingValue) : 0}
                            halfRating={parseInt(StarRatingValue) ? (Number.isInteger(StarRatingValue) ? 0 : 1) : 0}
                            total={5}
                            isInteractive={false}
                            className="mr-4"
                          />
                          {/* {parseInt(StarRatingValue) ? Math.round(StarRatingValue * 10) / 10 : 0} */}
              {/* </div>
                      ) : null}
                      {review > 0 ? (
                        <div
                          onClick={() => {
                            if (!quickView) {
                              const elmntToView = document.getElementById('Review');
                              elmntToView.scrollIntoView();
                            }
                          }}
                          className="text-black_variant_1 cursor-pointer underline text-14 md:text-16 pl-8 font-medium"
                        >
                          {review} Reviews
                        </div>
                      ) : null}
                    </div> */}
              {/* <div className="flex items-center mt-22">
                      <div className="flex text-pricing-current text-24 mr-14 font-bold">
                        <Rupee value={finalProduct.finalPrice} />
                      </div>
                      {product.hasDiscount ? (
                        <div className="flex line-through font-medium text-20 mt-2 text-disabledtext">
                          <Rupee value={finalProduct.price} />
                        </div>
                      ) : (
                        <div className="font-normal text-12">&nbsp;</div>
                      )}
                    </div> */}
              {/* <div className="text-16 md:mt-10 text-gray leading-24 font-medium">
                      <Editor
                        name="eventShortDescription"
                        value={finalProduct.shortDescription || product.shortDescription}
                        readonly={true}
                      />
                    </div> */}
              {/* {!readMore ? (
              <Button className="text-13 text-theme mt-9 focus:outline-none" onClick={() => setReadMore(true)}>
                Read More
              </Button>
            ) : (
              <Editor
                name="eventLongDescription"
                value={finalProduct.description || product.description}
                readonly={true}
              />
            )} */}
              {/* <div className="text-14 mb-16">{finalProduct.categories?.map((category) => category.name).join(', ')}</div> */}
              {/* <div className="flex flex-col mt-20">
                      <div className="flex">
                        <div className="text-14 md:text-16 tracking-14 md:tracking-16 text-black font-bold  min-w-100">
                          DATE
                        </div>
                        <div className="text-14 md:text-16 tracking-14 md:tracking-16 font-medium">
                          {eventStartDate === eventEndDate ? (
                            <>
                              <div>{eventStartDate},</div>
                              <div>
                                {eventStartTime} - {eventEndTime}
                              </div>
                            </>
                          ) : (
                            <>
                              {eventStartDate}&nbsp;&nbsp;{eventStartTime} - {eventEndDate}&nbsp;&nbsp;{eventEndTime}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="flex mt-22">
                        <div className="text-14 md:text-16 tracking-14 md:tracking-16 text-black font-bold  min-w-100">
                          VENUE
                        </div>
                        <div className="flex w-210 flex-wrap text-14 md:text-16 tracking-14 md:tracking-16 font-medium">
                          {finalProduct.event?.venue}
                        </div>
                      </div>
                    </div> */}
              {/* </div>
        <div className="md:w-1/3 md:pl-16"> */}
              <ProductAddToCart
                product={product}
                hocArgs={hocArgs}
                addToast={addToast}
                cartProductQuantity={cartProductQuantity}
                addProductToCart={addProductToCart}
                subtractProductFromCart={subtractProductFromCart}
                storeType={storeType}
                isEvent={true}
                quickView={quickView}
                review={review}
                scrollToReview={scrollToReview}
                wishListFeature={wishListFeature}
              />
            </div>
          </div>
        </div>
      </div>
      {/* {!quickView && <Share className="w-full" product={product} />} */}
    </div>
  );
};

export default Event;
